export type ParsedResourceId = {
  platform: string;
  application: string;
};

/**
 * `platform_application`: exactly one underscore, a platform of letters and digits only
 * and an application of letters, digits, hyphens and periods only.
 */
const RESOURCE_ID_PATTERN = /^([A-Za-z0-9]+)_([A-Za-z0-9.-]+)$/;

/**
 * Parses a `resourceId` such as `ump_env` into its platform and application.
 * Returns `null` when the value is missing or not in `platform_application` format.
 * The value is not trimmed or decoded.
 */
export const parseResourceId = (
  resourceId: string | null | undefined
): ParsedResourceId | null => {
  if (typeof resourceId !== "string") {
    return null;
  }

  const match = RESOURCE_ID_PATTERN.exec(resourceId);
  if (!match) {
    return null;
  }

  return { platform: match[1], application: match[2] };
};
